(function () {
  "use strict";

  var STORE_KEY = "afbd2eb0-431a-429e-90d6-437b746ebdbb";
  var API_BASE = "https://system.igmcore.pl/marketing/api/storefront/" + STORE_KEY;
  var NAVIGATION_URL = API_BASE + "/mobile-navigation/";
  var TRENDING_URL = API_BASE + "/mobile-navigation/trending/";
  var CLICK_URL = API_BASE + "/mobile-navigation/click/";

  var TRENDING_ITEMS = [];

  var ROOT_ID = "igm-mobile-navigation-root";
  var SEARCH_OVERLAY_ID = "igm-mobile-search-overlay";
  var CART_BADGE_SELECTOR = "[data-igm-mobile-cart-badge]";
  var PRODUCT_CACHE = {};

  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
    } else {
      callback();
    }
  }

  function safeText(value) {
    if (value === null || value === undefined) return "";
    return String(value).trim();
  }

  function safeBool(value, fallback) {
    if (value === true || value === "true" || value === 1 || value === "1") return true;
    if (value === false || value === "false" || value === 0 || value === "0") return false;
    return fallback;
  }

  function debounce(fn, delay) {
    var timer = null;

    return function () {
      var args = arguments;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        fn.apply(null, args);
      }, delay);
    };
  }

  function isMobile() {
    return window.matchMedia && window.matchMedia("(max-width: 767px)").matches;
  }

  function isTablet() {
    return window.matchMedia && window.matchMedia("(min-width: 768px) and (max-width: 1024px)").matches;
  }

  function isDesktop() {
    return !isMobile() && !isTablet();
  }

  function normalizeItems(data) {
    var items = [];

    if (Array.isArray(data.items)) {
      items = data.items;
    } else if (Array.isArray(data.navigation_items)) {
      items = data.navigation_items;
    } else if (data.navigation && Array.isArray(data.navigation.items)) {
      items = data.navigation.items;
    }

    return items
      .filter(function (item) {
        return item && safeBool(item.enabled, true);
      })
      .sort(function (a, b) {
        var ap = parseInt(a.position || 100, 10);
        var bp = parseInt(b.position || 100, 10);
        return ap - bp;
      });
  }

  function getSettings(data) {
    var colors = data.colors && typeof data.colors === "object" ? data.colors : {};

    return {
      enabled: safeBool(data.enabled, false),
      showOnMobile: safeBool(data.show_on_mobile !== undefined ? data.show_on_mobile : data.show_mobile, true),
      showOnTablet: safeBool(data.show_on_tablet !== undefined ? data.show_on_tablet : data.show_tablet, true),
      maxItems: parseInt(data.max_items || 5, 10),
      activeColor: safeText(colors.active || data.active_color || data.activeColor || "#ffffff"),
      textColor: safeText(colors.text || data.text_color || data.textColor || "#ffffff"),
      backgroundColor: safeText(colors.background || data.background_color || data.backgroundColor || "#1f513b"),
      borderColor: safeText(colors.border || data.border_color || data.borderColor || "#1f513b")
    };
  }

  function shouldRender(settings) {
    if (!settings.enabled) return false;
    if (isDesktop()) return false;
    if (isMobile() && !settings.showOnMobile) return false;
    if (isTablet() && !settings.showOnTablet) return false;
    return true;
  }

  function createRoot() {
    var existing = document.getElementById(ROOT_ID);
    if (existing) existing.remove();

    var root = document.createElement("nav");
    root.id = ROOT_ID;
    root.className = "igm-mobile-navigation";
    root.setAttribute("aria-label", "Nawigacja mobilna");
    document.body.appendChild(root);

    return root;
  }

  function iconSvg(name) {
    var icon = safeText(name || "circle").toLowerCase();

    var icons = {
      home: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 10.8 12 3l9 7.8V21a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1V10.8Z"/></svg>',
      search: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M10.8 4a6.8 6.8 0 1 1 0 13.6 6.8 6.8 0 0 1 0-13.6Zm0 2a4.8 4.8 0 1 0 0 9.6 4.8 4.8 0 0 0 0-9.6Zm5.2 9 4 4-1.4 1.4-4-4L16 15Z"/></svg>',
      gift: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 7h-2.2A3 3 0 0 0 12 5.8 3 3 0 0 0 6.2 7H4a1 1 0 0 0-1 1v4h18V8a1 1 0 0 0-1-1ZM9 6a1 1 0 1 1 1 1H8a1 1 0 0 1 1-1Zm6 0a1 1 0 0 1 1 1h-2a1 1 0 0 1 1-1ZM4 14v6a1 1 0 0 0 1 1h6v-7H4Zm9 0v7h6a1 1 0 0 0 1-1v-6h-7Z"/></svg>',
      sparkles: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l1.5 5 5 1.5-5 1.5-1.5 5-1.5-5-5-1.5 5-1.5L12 2Zm7 10 .9 3.1L23 16l-3.1.9L19 20l-.9-3.1L15 16l3.1-.9L19 12ZM5 13l1 3.5L9.5 18 6 19l-1 3.5L4 19 .5 18 4 16.5 5 13Z"/></svg>',
      cart: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 18a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm10 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM4.2 4H2V2h3.8l1 4H22l-2 8H8.3l.4 2H20v2H7a1 1 0 0 1-1-.8L4.2 4Z"/></svg>',
      heart: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7.5-4.7-9.6-9A5.7 5.7 0 0 1 12 5.7 5.7 5.7 0 0 1 21.6 12C19.5 16.3 12 21 12 21Z"/></svg>',
      user: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 12a5 5 0 1 0-5-5 5 5 0 0 0 5 5Zm0 2c-5 0-8 2.5-8 5.5V22h16v-2.5C20 16.5 17 14 12 14Z"/></svg>',
      menu: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16v2H4V6Zm0 5h16v2H4v-2Zm0 5h16v2H4v-2Z"/></svg>',
      contact: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm8 8.2L5.7 7H5v.5l7 6.8 7-6.8V7h-.7L12 13.2Z"/></svg>'
    };

    return icons[icon] || icons.home;
  }

  function setThemeVariables(root, settings) {
    root.style.setProperty("--igm-nav-active", settings.activeColor);
    root.style.setProperty("--igm-nav-text", settings.textColor);
    root.style.setProperty("--igm-nav-bg", settings.backgroundColor);
    root.style.setProperty("--igm-nav-border", settings.borderColor);
  }

  function currentPath() {
    return window.location.pathname || "/";
  }

  function isCurrentUrl(url) {
    var clean = safeText(url) || "/";
    if (clean === "/" || clean === "#menu" || clean === "#") return false;
    return currentPath().indexOf(clean) === 0;
  }

  function trackNavigationClick(item) {
    var payload;
    var body;

    item = item || {};

    payload = {
      label: safeText(item.label || item.title || ""),
      item_type: safeText(item.type || item.item_type || "link"),
      type: safeText(item.type || item.item_type || "link"),
      action: safeText(item.action || ""),
      action_type: safeText(item.action || ""),
      url: safeText(item.url || ""),
      target_url: safeText(item.url || ""),
      icon: safeText(item.icon || ""),
      source_path: window.location.pathname || "/",
      source_url: window.location.href || "",
      referrer: document.referrer || "",
      user_agent: navigator.userAgent || "",
      created_from: "shopify_mobile_navigation"
    };

    body = JSON.stringify(payload);

    try {
      if (navigator.sendBeacon) {
        var blob = new Blob([body], {
          type: "text/plain;charset=UTF-8"
        });

        navigator.sendBeacon(CLICK_URL, blob);
        return;
      }
    } catch (error) {}

    try {
      fetch(CLICK_URL, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain;charset=UTF-8"
        },
        body: body,
        credentials: "omit",
        keepalive: true
      }).catch(function () {});
    } catch (error) {}
  }

  function openThemeMenu() {
    var selectors = [
      "summary.header__icon--menu",
      "button.header__icon--menu",
      "button[aria-controls*='menu']",
      "button[aria-label*='Menu']",
      "button[aria-label*='menu']",
      ".header__icon--menu",
      ".menu-drawer__toggle",
      "[data-drawer-open]",
      "[data-menu-open]"
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var trigger = document.querySelector(selectors[i]);

      if (trigger) {
        trigger.click();
        return true;
      }
    }

    document.body.classList.toggle("igm-mobile-menu-requested");
    return false;
  }

  function makeItem(item) {
    var type = safeText(item.type || item.item_type || "link");
    var action = safeText(item.action || "");
    var label = safeText(item.label || item.title || "");
    var url = safeText(item.url || "#");
    var icon = safeText(item.icon || "circle");
    var badge = safeText(item.badge || "");

    var button;

    if (type === "search" || action === "search_focus") {
      button = document.createElement("button");
      button.type = "button";
      button.addEventListener("click", function () {
        trackNavigationClick(item);
        openSearch();
      });
    } else if (icon === "menu" || action === "menu" || url === "#menu") {
      button = document.createElement("button");
      button.type = "button";
      button.addEventListener("click", function () {
        trackNavigationClick(item);
        openThemeMenu();
      });
    } else {
      button = document.createElement("a");
      button.href = type === "cart" ? (url || "/cart") : (url || "#");
      button.addEventListener("click", function () {
        trackNavigationClick(item);
      });
    }

    button.className = "igm-mobile-navigation__item";
    button.setAttribute("aria-label", label || type);

    var promotionKey = [
      label,
      type,
      action,
      url,
      icon
    ]
      .map(function (value) {
        return safeText(value).toLowerCase();
      })
      .join(" ");

    var isPromotionItem =
      promotionKey.indexOf("promoc") !== -1 ||
      promotionKey.indexOf("promotion") !== -1;

    if (isPromotionItem) {
      button.className += " igm-mobile-navigation__item--promotion";
    }

    if (type !== "search" && isCurrentUrl(url)) {
      button.className += " is-active";
    }

    var iconWrap = document.createElement("span");
    iconWrap.className = "igm-mobile-navigation__icon";
    iconWrap.innerHTML = iconSvg(icon);

    var labelWrap = document.createElement("span");
    labelWrap.className = "igm-mobile-navigation__label";
    labelWrap.textContent = label;

    button.appendChild(iconWrap);
    button.appendChild(labelWrap);

    if (isPromotionItem) {
      var promotionAlert = document.createElement("span");
      promotionAlert.className = "igm-mobile-navigation__promotion-alert";
      promotionAlert.textContent = "!";
      promotionAlert.setAttribute("aria-hidden", "true");
      button.appendChild(promotionAlert);
    }

    if (type === "cart" || action === "cart") {
      var cartBadge = document.createElement("span");
      cartBadge.className = "igm-mobile-navigation__badge";
      cartBadge.setAttribute("data-igm-mobile-cart-badge", "1");
      cartBadge.textContent = badge || "0";
      button.appendChild(cartBadge);
    } else if (badge) {
      var staticBadge = document.createElement("span");
      staticBadge.className = "igm-mobile-navigation__badge";
      staticBadge.textContent = badge;
      button.appendChild(staticBadge);
    }

    return button;
  }

  function closeSearch() {
    var existing = document.getElementById(SEARCH_OVERLAY_ID);
    if (existing) existing.remove();
  }

  function openSearch() {
    closeSearch();

    var overlay = document.createElement("div");
    overlay.id = SEARCH_OVERLAY_ID;
    overlay.className = "igm-mobile-search";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.setAttribute("aria-label", "Wyszukiwarka");

    var panel = document.createElement("div");
    panel.className = "igm-mobile-search__panel";

    var head = document.createElement("div");
    head.className = "igm-mobile-search__head";

    var input = document.createElement("input");
    input.className = "igm-mobile-search__input";
    input.type = "search";
    input.placeholder = "Szukaj produktów…";
    input.autocomplete = "off";

    var submit = document.createElement("button");
    submit.type = "button";
    submit.className = "igm-mobile-search__submit";
    submit.textContent = "Szukaj";

    var close = document.createElement("button");
    close.type = "button";
    close.className = "igm-mobile-search__close";
    close.textContent = "×";
    close.setAttribute("aria-label", "Zamknij");
    close.addEventListener("click", closeSearch);

    var results = document.createElement("div");
    results.className = "igm-mobile-search__results";

    head.appendChild(input);
    head.appendChild(submit);
    head.appendChild(close);
    panel.appendChild(head);
    panel.appendChild(results);
    overlay.appendChild(panel);
    document.body.appendChild(overlay);

    function goToSearch() {
      var query = safeText(input.value);
      if (!query) return;
      window.location.href = "/search?q=" + encodeURIComponent(query);
    }

    submit.addEventListener("click", goToSearch);

    input.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        event.preventDefault();
        goToSearch();
      }

      if (event.key === "Escape") {
        closeSearch();
      }
    });

    overlay.addEventListener("click", function (event) {
      if (event.target === overlay) closeSearch();
    });

    input.addEventListener("input", debounce(function () {
      searchProducts(input.value, results);
    }, 250));

    renderTrendingProducts(results);

    window.setTimeout(function () {
      input.focus();
    }, 50);
  }

  function normalizeImageUrl(image) {
    if (!image) return "";

    if (typeof image === "string") {
      return image;
    }

    if (typeof image === "object") {
      return image.url || image.src || image.originalSrc || "";
    }

    return "";
  }

  function formatMoney(value) {
    var currency = "PLN";

    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        currency = window.Shopify.currency.active;
      }
    } catch (error) {}

    try {
      return new Intl.NumberFormat("pl-PL", {
        style: "currency",
        currency: currency
      }).format(value);
    } catch (error) {
      return value.toFixed(2).replace(".", ",") + " zł";
    }
  }

  function normalizePrice(price) {
    if (price === null || price === undefined || price === "") return null;

    if (typeof price === "object") {
      price = price.price || price.min || price.amount || price.value || null;
    }

    if (price === null || price === undefined || price === "") return null;

    if (typeof price === "string") {
      if (/[a-zł€$]/i.test(price)) return price;
      price = price.replace(",", ".");
    }

    var number = Number(price);
    if (!Number.isFinite(number)) return String(price);

    if (number > 999) {
      number = number / 100;
    }

    return formatMoney(number);
  }

  function getProductHandleFromUrl(url) {
    var clean = safeText(url);
    var match;

    if (!clean) return "";

    clean = clean.replace(/^https?:\/\/[^/]+/i, "");
    match = clean.match(/\/products\/([^/?#]+)/i);

    return match && match[1] ? decodeURIComponent(match[1]) : "";
  }

  function loadProductData(handle) {
    handle = safeText(handle);

    if (!handle) {
      return Promise.resolve(null);
    }

    if (PRODUCT_CACHE[handle]) {
      return PRODUCT_CACHE[handle];
    }

    PRODUCT_CACHE[handle] = fetch("/products/" + encodeURIComponent(handle) + ".js?t=" + Date.now(), {
      credentials: "same-origin",
      cache: "no-store"
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Product status " + response.status);
        return response.json();
      })
      .catch(function () {
        return null;
      });

    return PRODUCT_CACHE[handle];
  }

  function extractProductPrice(productData) {
    var variant = null;
    var price = null;
    var compareAtPrice = null;

    if (!productData) return null;

    if (Array.isArray(productData.variants) && productData.variants.length) {
      variant =
        productData.variants.find(function (item) {
          return item && item.available;
        }) || productData.variants[0];
    }

    if (variant) {
      price = variant.price;
      compareAtPrice = variant.compare_at_price;
    } else {
      price = productData.price;
      compareAtPrice = productData.compare_at_price;
    }

    price = Number(price || 0);
    compareAtPrice = Number(compareAtPrice || 0);

    if (!price) return null;

    return {
      price: price,
      compareAtPrice: compareAtPrice > price ? compareAtPrice : 0
    };
  }

  function renderPriceBox(priceBox, priceValue, compareValue) {
    var hasSale = compareValue && compareValue !== priceValue;

    if (!priceBox || !priceValue) {
      if (priceBox) priceBox.remove();
      return;
    }

    priceBox.classList.remove("is-loading");
    priceBox.classList.toggle("has-sale", !!hasSale);
    priceBox.innerHTML = "";

    if (hasSale) {
      var saleBadge = document.createElement("span");
      saleBadge.className = "igm-mobile-search__sale-badge";
      saleBadge.textContent = "PROMOCJA";
      priceBox.appendChild(saleBadge);
    }

    var current = document.createElement("span");
    current.className = "igm-mobile-search__price-current";
    current.textContent = priceValue;
    priceBox.appendChild(current);

    if (hasSale) {
      var compare = document.createElement("span");
      compare.className = "igm-mobile-search__price-compare";
      compare.textContent = compareValue;
      priceBox.appendChild(compare);
    }
  }

  function applyProductPrice(product, priceBox) {
    var handle = getProductHandleFromUrl(product.url || product.href || "");

    if (!handle || !priceBox) return;

    priceBox.classList.add("is-loading");

    loadProductData(handle).then(function (productData) {
      var priceData = extractProductPrice(productData);

      priceBox.classList.remove("is-loading");

      if (!priceData) {
        if (!priceBox.childNodes.length) priceBox.remove();
        return;
      }

      renderPriceBox(
        priceBox,
        normalizePrice(priceData.price),
        priceData.compareAtPrice ? normalizePrice(priceData.compareAtPrice) : ""
      );
    });
  }

  function renderProductList(products, query, target, options) {
    options = options || {};

    target.innerHTML = "";

    if (options.title) {
      var heading = document.createElement("div");
      heading.className = "igm-mobile-search__section-title";
      heading.textContent = options.title;
      target.appendChild(heading);
    }

    products.forEach(function (product) {
      var link = document.createElement("a");
      link.className = "igm-mobile-search__result";
      link.href = product.url || product.href || "/search?q=" + encodeURIComponent(query || "");

      var image = document.createElement("span");
      image.className = "igm-mobile-search__image";

      var imageUrl = normalizeImageUrl(product.image || product.featured_image || product.featuredImage);

      if (imageUrl) {
        var img = document.createElement("img");
        img.src = imageUrl;
        img.alt = "";
        image.appendChild(img);
      }

      var body = document.createElement("span");
      body.className = "igm-mobile-search__body";

      var title = document.createElement("span");
      title.className = "igm-mobile-search__title";
      title.textContent = product.title || product.name || "Produkt";

      var badgeValue = safeText(product.badge || product.label || product.tag || "");
      var badgeBackgroundColor = safeText(product.badge_background_color || product.badgeBackgroundColor || "#eef7f2");
      var badgeTextColor = safeText(product.badge_text_color || product.badgeTextColor || "#1f513b");

      body.appendChild(title);

      if (badgeValue) {
        var badge = document.createElement("span");
        badge.className = "igm-mobile-search__badge";
        badge.textContent = badgeValue;
        badge.style.backgroundColor = badgeBackgroundColor;
        badge.style.color = badgeTextColor;
        body.appendChild(badge);
      }

      var priceBox = document.createElement("span");
      priceBox.className = "igm-mobile-search__price-box";

      var priceValue = normalizePrice(product.price || product.price_min || product.priceMin);
      var compareValue = normalizePrice(product.compare_at_price || product.compareAtPrice || product.compare_at_price_min);

      if (priceValue) {
        renderPriceBox(priceBox, priceValue, compareValue);
      }

      link.appendChild(image);
      link.appendChild(body);
      link.appendChild(priceBox);

      target.appendChild(link);

      if (getProductHandleFromUrl(link.href || product.url || product.href || "")) {
        applyProductPrice(product, priceBox);
      } else if (!priceBox.childNodes.length) {
        priceBox.remove();
      }
    });

    if (query) {
      var all = document.createElement("a");
      all.className = "igm-mobile-search__fallback";
      all.href = "/search?q=" + encodeURIComponent(query);
      all.textContent = "Pokaż wszystkie wyniki";
      target.appendChild(all);
    }
  }

  function renderDefaultSuggestions(target) {
    target.innerHTML =
      '<div class="igm-mobile-search__section-title">Popularne wyszukiwania</div>' +
      '<a class="igm-mobile-search__fallback" href="/collections/personalizowane">Personalizowane produkty</a>' +
      '<a class="igm-mobile-search__fallback" href="/collections/all">Zobacz wszystkie produkty</a>';
  }

  function renderTrendingProducts(target) {
    target.innerHTML = '<div class="igm-mobile-search__empty">Ładuję propozycje…</div>';

    fetch(TRENDING_URL + "?t=" + Date.now(), {
      method: "GET",
      headers: {
        Accept: "application/json"
      },
      credentials: "omit",
      cache: "no-store"
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Trending status " + response.status);
        return response.json();
      })
      .then(function (data) {
        var items = [];

        if (Array.isArray(data.items)) {
          items = data.items;
        } else if (Array.isArray(data.products)) {
          items = data.products;
        } else if (data.trending && Array.isArray(data.trending.items)) {
          items = data.trending.items;
        }

        if (!items.length) {
          items = TRENDING_ITEMS;
        }

        if (!items.length) {
          renderDefaultSuggestions(target);
          return;
        }

        renderProductList(items.slice(0, 6), "", target, {
          title: "Polecane"
        });
      })
      .catch(function () {
        if (TRENDING_ITEMS.length) {
          renderProductList(TRENDING_ITEMS.slice(0, 6), "", target, {
            title: "Polecane"
          });
          return;
        }

        renderDefaultSuggestions(target);
      });
  }

  function searchProducts(query, target) {
    query = safeText(query);

    if (query.length < 2) {
      renderTrendingProducts(target);
      return;
    }

    target.innerHTML = '<div class="igm-mobile-search__empty">Szukam…</div>';

    var url = "/search/suggest.json?q=" + encodeURIComponent(query) + "&resources[type]=product&resources[limit]=6";

    fetch(url, { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("Search status " + response.status);
        return response.json();
      })
      .then(function (data) {
        var products =
          data &&
          data.resources &&
          data.resources.results &&
          Array.isArray(data.resources.results.products)
            ? data.resources.results.products
            : [];

        if (!products.length) {
          target.innerHTML =
            '<a class="igm-mobile-search__fallback" href="/search?q=' +
            encodeURIComponent(query) +
            '">Brak podpowiedzi. Pokaż wyniki wyszukiwania</a>';
          return;
        }

        renderProductList(products, query, target, {
          title: "Podpowiedzi"
        });
      })
      .catch(function () {
        target.innerHTML =
          '<a class="igm-mobile-search__fallback" href="/search?q=' +
          encodeURIComponent(query) +
          '">Przejdź do wyników wyszukiwania</a>';
      });
  }

  function updateCartCount() {
    fetch("/cart.js?t=" + Date.now(), {
      credentials: "same-origin",
      cache: "no-store"
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Cart status " + response.status);
        return response.json();
      })
      .then(function (cart) {
        var count = parseInt(cart.item_count || 0, 10);
        var badges = document.querySelectorAll(CART_BADGE_SELECTOR);

        Array.prototype.forEach.call(badges, function (badge) {
          badge.textContent = String(count);
          badge.style.display = count > 0 ? "inline-flex" : "none";
        });
      })
      .catch(function () {});
  }

  function setupCartAutoRefresh() {
    var refresh = debounce(function () {
      updateCartCount();
    }, 350);

    document.addEventListener("cart:updated", refresh);
    document.addEventListener("cart:refresh", refresh);
    document.addEventListener("ajaxCart:updated", refresh);
    document.addEventListener("product:added", refresh);
    document.addEventListener("cart:change", refresh);
    document.addEventListener("variant:add", refresh);

    window.addEventListener("focus", refresh);
    window.addEventListener("pageshow", refresh);

    var originalFetch = window.fetch;

    if (typeof originalFetch === "function" && !window.__igmCartFetchPatched) {
      window.__igmCartFetchPatched = true;

      window.fetch = function () {
        var args = arguments;
        var requestUrl = "";

        try {
          requestUrl = typeof args[0] === "string" ? args[0] : args[0].url || "";
        } catch (error) {}

        return originalFetch.apply(window, args).then(function (response) {
          if (/\/cart\/add|\/cart\/change|\/cart\/update|\/cart\/clear|\/cart\.js/.test(requestUrl)) {
            window.setTimeout(refresh, 200);
            window.setTimeout(refresh, 800);
            window.setTimeout(refresh, 1600);
          }

          return response;
        });
      };
    }

    if (window.XMLHttpRequest && !window.__igmCartXhrPatched) {
      window.__igmCartXhrPatched = true;

      var originalOpen = window.XMLHttpRequest.prototype.open;
      var originalSend = window.XMLHttpRequest.prototype.send;

      window.XMLHttpRequest.prototype.open = function (method, url) {
        this.__igmCartUrl = safeText(url);
        return originalOpen.apply(this, arguments);
      };

      window.XMLHttpRequest.prototype.send = function () {
        var xhr = this;

        xhr.addEventListener("loadend", function () {
          if (/\/cart\/add|\/cart\/change|\/cart\/update|\/cart\/clear|\/cart\.js/.test(xhr.__igmCartUrl || "")) {
            window.setTimeout(refresh, 200);
            window.setTimeout(refresh, 800);
            window.setTimeout(refresh, 1600);
          }
        });

        return originalSend.apply(this, arguments);
      };
    }
  }

  function render(data) {
    data = data || {};

    var settings = getSettings(data);
    var items = normalizeItems(data);

    if (!shouldRender(settings)) return;
    if (!items.length) return;

    var root = createRoot();
    setThemeVariables(root, settings);

    items.slice(0, settings.maxItems || 5).forEach(function (item) {
      root.appendChild(makeItem(item));
    });

    updateCartCount();
    setupCartAutoRefresh();

    window.setInterval(updateCartCount, 15000);

    document.body.classList.add("igm-mobile-navigation-visible");
  }

  function loadNavigation() {
    fetch(NAVIGATION_URL + "?t=" + Date.now(), {
      method: "GET",
      headers: {
        Accept: "application/json"
      },
      credentials: "omit",
      cache: "no-store"
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Mobile navigation status " + response.status);
        return response.json();
      })
      .then(render)
      .catch(function (error) {
        if (window.console && window.console.warn) {
          window.console.warn("[IGM mobile navigation]", error);
        }
      });
  }

  ready(loadNavigation);
})();